import { forgotPasswordUrl } from '../lib/paths';
import { usePostData } from '../lib/hooks/requests';

export const useForgotPassword = () => {
  return usePostData(forgotPasswordUrl);
};
